// HTMLComponent.jsx
import React from 'react';

const HTMLComponent = () => {
    const htmlContent = `
    <!DOCTYPE html>
    <html lang="en">

    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Instagram Stories</title>
        <link rel="stylesheet" href="index.css">
    </head>

    <body>
        <div id="instagram-stories"></div>
        <script type="module" src="index.js"></script>
        <script type="module" src="server.js"></script>
    </body>

    </html>
  `;

    return (
        <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    );
};

export default HTMLComponent;
